module.exports = __webpack_public_path__ + "img/Fuge.536138e3.jpg";